export default "__VITE_ASSET__d52cb49e__"